import React, { useState } from 'react';

const CategoryButton = ({ onClick, children, theme }) => {
  const [isHovered, setIsHovered] = useState(false);
  
  return (
    <button
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        width: '100%',
        padding: '10px 20px',
        background: isHovered ? (theme.isDarkMode ? 'rgba(0, 153, 255, 0.1)' : theme.colors.buttonBackgroundHover) : 'transparent',
        border: `2px dashed ${isHovered ? theme.colors.buttonText : (theme.isDarkMode ? 'rgba(255, 255, 255, 0.2)' : '#666666')}`,
        borderRadius: '8px',
        color: theme.isDarkMode ? theme.colors.buttonText : '#0066cc',
        fontSize: '15px',
        textAlign: 'center',
        cursor: 'pointer',
        transition: 'all 0.2s ease'
      }}
    >
      {children}
    </button>
  );
};

export default CategoryButton; 